export default __webpack_public_path__ + "static/media/notice_warning.57f33716.svg";